<template>
  <div class="t-dropdown" :class="!disabled && 'disabled'" v-if="active">
    <div class="t-dropdown__wrapper" @click="() => this.show = !this.show">
      <div class="t-dropdown__icon">
        <img src="/img/icon/therapist.svg" alt="">
      </div>
      <div class="t-dropdown__title">
        {{ active.last_name }}, {{ active.first_name }}
      </div>
      <div class="t-dropdown__arrow">
        <img src="/img/icon/arrow-down.svg" alt="">
      </div>
    </div>
    <div class="t-dropdown__content" :class="show && 'active'">
      <div class="t-dropdown__text">
        Switch Therapist View:
      </div>
      <vueCustomScrollbar class="t-dropdown__list" v-if="list && list.length > 0">
        <div v-for="item in items" :key="item.id" class="t-dropdown__item" @click="select(item)">
          {{ item.last_name }}, {{ item.first_name }}
        </div>
      </vueCustomScrollbar>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  props: ['list', 'active', 'disabled'],
  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    items() {
      return this.list.filter((item) => item.id !== this.active.id);
    },
  },
  methods: {
    select(e) {
      this.show = false;
      this.$emit('change', e);
    },
    clickHandler(e) {
      const item = document.querySelector('.t-dropdown');
      if (item) {
        if (!item.contains(e.target)) {
          this.show = false;
        }
      }
    },
  },
  mounted() {
    document.body.addEventListener('click', this.clickHandler);
  },
  destroyed() {
    document.body.removeEventListener('click', this.clickHandler);
  },
};
</script>

<style lang="scss">
  .t-dropdown {
    position: relative;
    &.disabled {
      pointer-events: none;
      .t-dropdown__arrow {
        opacity: 0;
      }
      .t-dropdown__content {
        display: none;
      }
    }
    .ps__rail-y {
      right: 10px !important;
    }
    &__wrapper {
      height: 40px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__title {
      padding: 0 28px 0 24px;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 200px;
      min-width: 140px;
    }
    &__content {
      position: absolute;
      background-color: #fff;
      border: 1px solid #c8c5c5;
      box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      top: 100%;
      right: -30px;
      left: 40px;
      padding: 15px 0;
      z-index: 1;
      box-sizing: border-box;
      opacity: 0;
      transition: .3s;
      pointer-events: none;
      &.active {
        opacity: 1;
        pointer-events: auto;
      }
      &:before {
        content: "";
        position: absolute;
        width: 15px;
        height: 15px;
        border-radius: 2px;
        background-color: #fff;
        border: 1px solid #c8c5c5;
        transform: rotate(45deg) skew(10deg, 10deg);
        top: -6px;
        right: 26px;
        z-index: -1;
      }
      &:after {
        content: "";
        background-color: #fff;
        height: 18px;
        width: 29px;
        position: absolute;
        right: 19px;
        top: 0;
      }
    }
    &__text {
      padding: 0 15px 6px 15px;
      color: #9aa1af;
      font-size: 16px;
      letter-spacing: -0.18px;
      border-bottom: 1px solid #e5e5e5;
    }
    &__list {
      padding-top: 9px;
      padding-right: 10px;
      max-height: 200px;
      margin-right: -10px;
      overflow: hidden;
    }
    &__item {
      font-size: 16px;
      color: #666666;
      letter-spacing: -0.18px;
      font-weight: 400;
      padding: 7px 15px;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &:hover {
        background-color: rgba(#fea478, .2);
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__arrow {
      display: flex;
      align-items: center;
      img {
        width: 12px;
      }
    }
  }
</style>
